// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inline-iframe-container {
  height: 300px;
  padding: 0 16px;
}
.inline-iframe-container .iframe-section {
  height: 100%;
  width: 100%;
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 4px;
}

.thumbnails-wrapper {
  padding: 12px 16px;
  display: inline-block;
  width: 100%;
  animation-name: bubbleAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.thumbnails-wrapper .icon-block {
  display: none;
}
.thumbnails-wrapper.forms-thumbnails {
  margin-top: 30px;
  padding: 0 16px;
}
.thumbnails-wrapper.forms-thumbnails .thumbnail-data-content .icon-block {
  width: 44px;
  height: 44px;
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: -38px 0 14px 0;
}
.thumbnails-wrapper.forms-thumbnails .thumbnail-data-content .icon-block svg path {
  fill: var(--sdk-gloabl-text-color);
}
.thumbnails-wrapper .thumbnail-data-content {
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 4px;
  padding: 15px;
  max-width: 75%;
  transition: 0.3s all ease;
  cursor: pointer;
}
.thumbnails-wrapper .thumbnail-data-content:hover {
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  transform: scale(1.03);
}
.thumbnails-wrapper .thumbnail-data-content h1 {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--sdk-gloabl-text-color);
  margin-bottom: 8px;
}
.thumbnails-wrapper .thumbnail-data-content p {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--sdk-gloabl-text-color);
}
.thumbnails-wrapper .thumbnail-data-content .kr-button-blue-light {
  width: 100%;
  flex-shrink: 0;
}
.thumbnails-wrapper .thumbnail-data-content .attchment-details .content-info audio {
  width: 100%;
}
.thumbnails-wrapper .thumbnail-data-content .attchment-details .content-info video {
  width: 100%;
}
.thumbnails-wrapper .thumbnail-data-content .link-btn {
  padding: 6px 0px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: var(--sdk-global-theme-color);
  cursor: pointer;
  background: transparent;
  border: 0;
  margin-top: 8px;
}
.thumbnails-wrapper.attachment-document {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 30px;
  padding: 0 16px;
}
.thumbnails-wrapper.attachment-document .thumbnail-data-content .icon-block {
  width: 44px;
  height: 44px;
  background: var(--sdk-global-white-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: var(--sdk-gloabl-text-color);
  margin: -38px 0 14px 0;
}
.thumbnails-wrapper.attachment-document .thumbnail-data-content {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/digitalForm/digitalForm.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;AACJ;AAAI;EACI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,gDAAA;EACA,kBAAA;AAER;;AAEA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AACJ;AAAI;EACI,aAAA;AAER;AAAI;EACI,gBAAA;EACA,eAAA;AAER;AAAY;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,gDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;AAEhB;AAAoB;EACI,kCAAA;AAExB;AAII;EACI,sCAAA;EACA,gDAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AAFR;AAGQ;EACI,mDAAA;EACA,sBAAA;AADZ;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AADZ;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;AADZ;AAGQ;EACI,WAAA;EACA,cAAA;AADZ;AAKgB;EACI,WAAA;AAHpB;AAKgB;EACI,WAAA;AAHpB;AAOQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AALZ;AAQI;EACI,aAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AANR;AAQY;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,gDAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mCAAA;EACA,sBAAA;AANhB;AANQ;EAcI,WAAA;AALZ","sourcesContent":[".inline-iframe-container {\n    height: 300px;\n    padding: 0 16px;\n    .iframe-section {\n        height: 100%;\n        width: 100%;\n        background: var(--sdk-global-white-bg);\n        border: 1px solid var(--sdk-gloabl-border-color);\n        border-radius: 4px;\n    }\n}\n\n.thumbnails-wrapper{\n    padding: 12px 16px;\n    display: inline-block;\n    width: 100%;\n    animation-name: bubbleAnim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    .icon-block{\n        display: none;\n    }\n    &.forms-thumbnails{\n        margin-top: 30px;\n        padding: 0 16px;\n        .thumbnail-data-content{\n            .icon-block{\n                width: 44px;\n                height: 44px;\n                background: var(--sdk-global-white-bg);\n                border: 1px solid var(--sdk-gloabl-border-color);\n                border-radius: 24px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 20px;                \n                margin: -38px 0 14px 0;\n                svg{\n                    path{\n                        fill: var(--sdk-gloabl-text-color);\n                    }\n                }\n            }\n        }\n    }\n    .thumbnail-data-content{\n        background: var(--sdk-global-white-bg);\n        border: 1px solid var(--sdk-gloabl-border-color);\n        border-radius: 4px;\n        padding: 15px;\n        max-width: 75%;\n        transition: 0.3s all ease;\n        cursor: pointer;\n        &:hover{\n            box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n            transform: scale(1.03);\n        }\n        h1{\n            font-weight: 600;\n            font-size: 14px;\n            line-height: 17px;\n            color: var(--sdk-gloabl-text-color);\n            margin-bottom: 8px;\n        }\n        p{\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 15px;\n            color: var(--sdk-gloabl-text-color);\n        }\n        .kr-button-blue-light{\n            width: 100%;\n            flex-shrink: 0;\n        }\n        .attchment-details {\n            .content-info {\n                audio {\n                    width: 100%;\n                }\n                video {\n                    width: 100%;\n                }\n            }\n        }\n        .link-btn{\n            padding: 6px 0px;\n            font-weight: 500;\n            font-size: 12px;\n            line-height: 18px;\n            color: var(--sdk-global-theme-color);\n            cursor: pointer;\n            background: transparent;\n            border: 0;\n            margin-top: 8px;\n        }\n    }\n    &.attachment-document{\n        display: flex;\n        width: 100%;\n        justify-content: flex-end;\n        margin-top: 30px;\n        padding: 0 16px;\n        .thumbnail-data-content{\n            .icon-block{\n                width: 44px;\n                height: 44px;\n                background: var(--sdk-global-white-bg);\n                border: 1px solid var(--sdk-gloabl-border-color);\n                border-radius: 24px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 20px;\n                color: var(--sdk-gloabl-text-color);\n                margin: -38px 0 14px 0;\n            }\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
